module.exports = __webpack_public_path__ + "static/media/PartnerSAPLogo.416f3724.png";